"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var grippyIcon = function grippyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width,
    height: props.height,
    viewBox: "0 0 20 20",
    className: props.className
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M6 1h2.8v3.033H6V1zm5 0h2.8v3.033H11V1zM6 5.983h2.8v3.034H6V5.983zM11 6h2.8v3.033H11V6zm-5 5h2.8v3.033H6V11zm0 4.983h2.8v3.034H6v-3.034zM11 11h2.8v3.033H11V11zm0 5h2.8v3.033H11V16z"
  }));
};
var GrippyIcon = (0, _styledComponents["default"])(grippyIcon).withConfig({
  displayName: "grippy__GrippyIcon"
})(["cursor:move;vertical-align:", ";"], function (props) {
  return props.verticalAlign;
});
GrippyIcon.displayName = 'GrippyIcon';
GrippyIcon.propTypes = {
  height: _propTypes["default"].number,
  width: _propTypes["default"].number,
  verticalAlign: _propTypes["default"].string,
  color: _propTypes["default"].string
};
var defaultProps = {
  width: 20,
  height: 20,
  verticalAlign: 'baseline',
  color: _constants.colors.lightGrey
};
GrippyIcon.defaultProps = defaultProps;
var _default = GrippyIcon;
exports["default"] = _default;